function setupMediaDisclaimer() {
  console.log('Setup MediaDisclaimer');
  let acceptBtn = document.getElementById('md-accept');
  let closeBtn = document.querySelector('#media-disclaimer .closeBtn');
  acceptBtn.addEventListener('click', acceptMediaDisclaimer);
  closeBtn.addEventListener('click', cancelMediaDisclaimer);

  let requires = document.querySelectorAll('[data-require="media-disclaimer"]');
  if (requires) {
    requires.forEach( function(el, idx) {
      el.addEventListener('click', showMediaDisclaimer);
    });
  }
}

function setupLinkDisclaimer() {
  console.log('Setup LinkDisclaimer');
  // remove subdomain of current site's url and setup regex
  let internal = location.host.replace("www.", "");
  internal = new RegExp(internal, "i");

  window.addEventListener('contextmenu', function (evt) {
    if (evt.target.getAttribute('data-require')) {
      evt.preventDefault();
    }
  });

  let acceptBtn  = document.getElementById('el-accept');
  let cancelBtn  = document.getElementById('el-cancel');
  let closeBtn   = document.querySelector('#ext-link-disclaimer .closeBtn');
  acceptBtn.addEventListener('click', acceptLinkDisclaimer);
  closeBtn.addEventListener('click', cancelLinkDisclaimer);
  cancelBtn.addEventListener('click', cancelLinkDisclaimer);

  let a = document.getElementsByTagName('a'); // then, grab every link on the page
  const alen = a.length;
  for (let i = 0; i < alen; i++) {
    let host = a[i].host; // set the host of each link
    let href = a[i].getAttribute("href"); // set the host of each link
    let isLocal = internal.test(host);
    let isJs = /^javascript/.test(href);
    let isPdf = /\.pdf$/.test(href);
    let isMail = /^mailto/.test(href);
    let isExtern = (a[i].getAttribute("data-require") == 'ext-link-disclaimer')?true:false;

    if ((!isLocal && !isJs && !isPdf && !isMail) || isExtern) { // make sure the href doesn't contain current site's host
      a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
      a[i].setAttribute('data-href',href);
      a[i].setAttribute('href','');
      a[i].addEventListener('click', showLinkDisclaimer);
    }
  }
}

function setupNonHcpDisclaimer() {
  console.log('Setup NonHcpDisclaimer');
  const acceptBtn = document.getElementById('non-hcp-accept');
  const closeBtn = document.querySelector('#non-hcp-disclaimer .closeBtn');
  acceptBtn.addEventListener('click', acceptNonHcpDisclaimer);
  closeBtn.addEventListener('click', cancelNonHcpDisclaimer);

  const requires = document.querySelector('body[data-require="non-hcp-disclaimer"]');
  if (requires) {
    showNonHcpDisclaimer();
  }
}

function showMediaDisclaimer(evt) {
  evt.preventDefault();
  let disclaimer = document.getElementById('media-disclaimer');
  let expiry = new Date(new Date().getTime() + 60 * 1000);
  let link = evt.currentTarget.href;
  if (/#/.test(link)) {
    link = evt.target.getAttribute('data-href') || '';
  }
  document.cookie = "md_redirect=" + link + "; path=/; expires=" + expiry.toUTCString();

  if (disclaimerAccepted('md_redirect') === true) {
    window.location = link;
  } else {
    disclaimer.classList.remove('hidden');
  }
}

function showLinkDisclaimer(evt) {
  evt.preventDefault();
  let link = evt.target.getAttribute('data-href') || '';
  let disclaimer = document.getElementById('ext-link-disclaimer');
  disclaimer.classList.remove('hidden');
  let expiry = new Date(new Date().getTime() + 60 * 1000);

  document.cookie = "el_redirect=" + link + "; path=/; expires=" + expiry.toUTCString();
}

function showNonHcpDisclaimer() {
  let disclaimer = document.getElementById('non-hcp-disclaimer');
  if ( !disclaimerAccepted('non_hcp_accept') ) {
    disclaimer.classList.remove('hidden');
  }
}

function acceptMediaDisclaimer(evt) {
  evt.preventDefault();
  let checkBox = document.getElementById('md-remember');
  if (checkBox && checkBox.checked) {
    setDisclaimerAccepted('md_accept');
  }
  let disclaimer = document.getElementById('media-disclaimer');
  disclaimer.classList.add('hidden');
  let redirect = getCookie('md_redirect');
  if (redirect !== null) {
    window.location = redirect;
  }
}

function acceptLinkDisclaimer(evt) {
  evt.preventDefault();
  let disclaimer = document.getElementById('ext-link-disclaimer');
  disclaimer.classList.add('hidden');
  let redirect = getCookie('el_redirect');
  if (redirect !== null) {
    window.open(redirect, '_blank');
  }
}

function acceptNonHcpDisclaimer(evt) {
  evt.preventDefault();
  let checkBox = document.getElementById('non-hcp-remember');
  if (checkBox && checkBox.checked) {
    setDisclaimerAccepted('non_hcp_accept');
  }
  let disclaimer = document.getElementById('non-hcp-disclaimer');
  disclaimer.classList.add('hidden');
}

function cancelNonHcpDisclaimer(evt) {
  evt.preventDefault();
  window.location = '/';
}

function cancelMediaDisclaimer(evt) {
  evt.preventDefault();
  let disclaimer = document.getElementById('media-disclaimer');
  disclaimer.classList.add('hidden');
}

function cancelLinkDisclaimer(evt) {
  evt.preventDefault();
  let disclaimer = document.getElementById('ext-link-disclaimer');
  disclaimer.classList.add('hidden');
}

function disclaimerAccepted(cookieName = 'dummy') {
  let pattern = new RegExp(cookieName + '=1', 'g');
  return !! pattern.test(document.cookie);
}

function setDisclaimerAccepted(cookieName = 'dummy') {
  const expiry = new Date(new Date().getTime() + 30 * 24 * 3600 * 1000);
  document.cookie = cookieName + "=1; path=/; expires=" + expiry.toUTCString();
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

document.addEventListener("DOMContentLoaded", function(event) {
  setupMediaDisclaimer();
  setupLinkDisclaimer();
  setupNonHcpDisclaimer();
});
